import createApp from "@shopify/app-bridge";
import { getSessionToken } from "@shopify/app-bridge-utils";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as config from "./aws-exports";
import Client from "aws-appsync";
import Amplify from "aws-amplify";
import { ApolloProvider } from "@apollo/react-hooks";
import { Rehydrated } from "components";
import { InMemoryCache } from "apollo-cache-inmemory";

const queryString = window.location.search;
const params = new URLSearchParams(queryString);
let client;

if (params.get("shop")) {
  window.Shopify = {
    currency: {
      rate: 1
    }
  };

  Amplify.configure({
    // Auth: {
    //   cookieStorage: {
    //     domain: config.AUTH_COOKIE_DOMAIN,
    //     expires: config.AUTH_COOKIE_EXPIRES,
    //     path: config.AUTH_COOKIE_PATH,
    //     secure: true,
    //     sameSite: "none"
    //   },
    //   identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID,
    //   region: config.AWS_COGNITO_REGION,
    //   userPoolId: config.AWS_COGNITO_USER_POOL_ID,
    //   userPoolWebClientId: config.AWS_COGNITO_USER_POOL_CLIENT_ID
    // },
    API: {
      endpoints: [
        {
          name: "API_GATEWAY_NEW",
          endpoint: config.API_GATEWAY_NEW,
          custom_header: async () => {
            return {
              Authorization: `Bearer ${await getSessionToken(shopifyApp)}`
            };
          }
        },
        {
          name: "API_GATEWAY",
          endpoint: config.API_GATEWAY,
          custom_header: async () => {
            return {
              Authorization: `Bearer ${await getSessionToken(shopifyApp)}`
            };
          }
        }
      ]
    },
    aws_appsync_graphqlEndpoint: config.APPSYNC_ENDPOINT,
    aws_appsync_region: config.APPSYNC_REGION,
    aws_appsync_authenticationType: "AWS_LAMBDA"
  });

  const cache = new InMemoryCache();
  const shopifyApp = createApp({
    apiKey: config.SHOPIFY_API_KEY,
    shopOrigin: params.get("shop"), // to handle login page
    host: params.get("host") || btoa(params.get("shop"))
  });
  client = new Client({
    auth: {
      token: async () => {
        const token = await getSessionToken(shopifyApp);
        return token;
      },
      type: "AWS_LAMBDA"
    },
    region: config.APPSYNC_REGION,
    url: config.APPSYNC_ENDPOINT,
    disableOffline: true,
    cache
  });

  window.shop = params.get("shop");
}


ReactDOM.render(
  client ? <ApolloProvider client={client}>
    <Rehydrated>
      <App />
    </Rehydrated>
  </ApolloProvider> : <App />,
  document.getElementById("app")
);
